(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5621],{

/***/ 39302:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basic-elements/webdienst-footer",
      function () {
        return __webpack_require__(44232);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62670);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60487);
/* harmony import */ var _components_codeHighlights_FooterCode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41215);






var Page = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: "Webdienst-Footer",
                description: "Basiselemente - Das Footer-Element f\xfcr FHNW-Webdienste.",
                canonical: "".concat("https://web.fhnw.ch/fhnw-styleguide-v5").concat((0,_lib_helpers__WEBPACK_IMPORTED_MODULE_2__/* .GetPathName */ .R)())
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                children: "Webdienst-Footer"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "lead",
                children: [
                    "Verwenden Sie diesen Footer f\xfcr",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "/webdienste",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: "FHNW-Webdienste"
                        })
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_codeHighlights_FooterCode__WEBPACK_IMPORTED_MODULE_5__/* .WebdienstFooterCode */ .C, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ }),

/***/ 41215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ WebdienstFooterCode; },
/* harmony export */   "M": function() { return /* binding */ ToolsFooterCode; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_ToastHighLighter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19203);


var ToolsFooterCode = function() {
    var language = "html";
    var name = "toolsfooter";
    var codeString = '\n  // Tools-Footer\n  <footer id="footer">\n    <div class="container tools__footer pt-4">\n      <div class="row">\n        <div class="d-flex justify-content-center">\n          <p>\n            <a href="https://www.fhnw.ch" target="_blank">\n              www.fhnw.ch\n            </a>\n            <span class="d-inline-block mx-1 mx-md-2">|</span>\n            <a href="#">Impressum</a>\n            <span class="d-inline-block mx-1 mx-md-2">|</span>\n            <a href="#">Datenschutz</a>\n          </p>\n        </div>\n      </div>\n    </div>\n  </footer>\n  ';
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lib_ToastHighLighter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            name: name,
            codeString: codeString,
            language: language,
            show: true
        })
    });
};
var WebdienstFooterCode = function() {
    var language = "html";
    var name = "toolsfooter";
    var codeString = '\n  // Webdienst-Footer\n  <footer id="footer">\n    <div class="container">\n      <div class="row">\n        <div class="col-xs-12 col-sm-6 col-md-4">\n          <h4>Kontakt</h4>\n          <p>\n            Fachhochschule Nordwestschweiz FHNW\n            <br />\n            Institute\n            <br />\n            Division\n            <br />\n            Street<br />\n            Zip Location\n          </p>\n          <p>\n            E-Mail: <a href="mailto:#">E-Mail</a>\n          </p>\n\n          <!-- Social Media Icons -->\n          ...\n        </div>\n        <div class="col-xs-12 col-sm-12 col-md-4 order-first order-md-0">\n          <h4>\xdcber diese Website</h4>\n          <p>\n            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Recusandae vel esse obcaecati minus!\n            Aperiam quibusdam, voluptatem est recusandae neque veritatis sunt.\n            Corporis quibusdam ad vitae consequuntur nemo, atque error iste.\n          </p>\n        </div>\n        <div class="col-xs-12 col-sm-6 col-md-4">\n          <h4>Quicklinks</h4>\n          <p>\n            <a href="#">\n              Link\n            </a>\n            <br />\n            <a href="#">Link</a>\n            <br />\n            <a href="#">\n              Link\n            </a>\n            <br />\n            <a href="#">Quicklinks</a>\n          </p>\n        </div>\n      </div>\n    </div>\n    <div class="container tools__footer">\n      <div class="row">\n        <div class="d-flex justify-content-center">\n          <p>\n            <a href="https://www.fhnw.ch" target="_blank">\n              www.fhnw.ch\n            </a>\n            <span class="d-inline-block mx-1 mx-md-2">|</span>\n            <a href="#">Impressum</a>\n            <span class="d-inline-block mx-1 mx-md-2">|</span>\n            <a href="#">Datenschutz</a>\n          </p>\n        </div>\n      </div>\n    </div>\n  </footer>\n  ';
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lib_ToastHighLighter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            name: name,
            codeString: codeString,
            language: language,
            show: true
        })
    });
};


/***/ }),

/***/ 19203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_ToastHighLighter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/esm/prism.js + 15 modules
var prism = __webpack_require__(5227);
// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/cjs/styles/prism/index.js
var styles_prism = __webpack_require__(84283);
;// CONCATENATED MODULE: ./src/lib/HighLighter.tsx



var CodeHighLight = function(param) {
    var codeString = param.codeString, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(prism/* default */.Z, {
        language: language,
        wrapLines: true,
        showLineNumbers: true,
        style: styles_prism/* dracula */.cL,
        children: codeString
    });
};
/* harmony default export */ var HighLighter = (CodeHighLight);

// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/lib/ToastHighLighter.tsx




var ToastHighLighter = function(param) {
    var name = param.name, codeString = param.codeString, language = param.language, show = param.show, _disableCopy = param.disableCopy, disableCopy = _disableCopy === void 0 ? false : _disableCopy;
    var ref = (0,react.useState)(false), state = ref[0], setState = ref[1];
    var handleClick = function() {
        setState(true);
        setTimeout(function() {
            setState(false);
        }, 5000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "btn btn-light btn-sm text-uppercase",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#".concat(name),
                "aria-expanded": "".concat(show ? "true" : "false"),
                "aria-controls": name,
                children: language
            }),
            disableCopy === false ? /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                text: codeString,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "btn btn-info btn-sm",
                    onClick: handleClick,
                    children: "Code kopieren"
                })
            }) : false,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collapse ".concat(show ? "show" : false),
                id: name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card card-body highlighter",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighLighter, {
                        codeString: codeString,
                        language: language
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "position-fixed top-0 end-0 p-3",
                style: {
                    zIndex: 1100
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "liveToast",
                    className: "toast ".concat(state ? "show" : "hide"),
                    role: "alert",
                    "aria-live": "assertive",
                    "aria-atomic": "true",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "toast-header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: "me-auto",
                                    children: "Code copied to clipboard"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "btn-close",
                                    "data-bs-dismiss": "toast",
                                    "aria-label": "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "toast-body",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighLighter, {
                                codeString: codeString,
                                language: language
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var lib_ToastHighLighter = (ToastHighLighter);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,5063,9774,2888,179], function() { return __webpack_exec__(39302); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);